const convertDate = (date?: number): string => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toISOString().split("T")[0];
};

const convertDateIso = (date?: string): string => {
  if (date == undefined) {
    return "";
  }
  return new Date(date).toISOString().split("T")[0];
};

const convertDateBrComHora = (date?: number) => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toLocaleString("en-GB");
};

const convertDateBrComHoraSafe = (value?: number | string | null): string => {
  if (value === null || value === undefined) {
    return "";
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) {
      return "";
    }
    const num = Number(trimmed);
    if (!Number.isFinite(num) || num <= 0) {
      return "";
    }
    return convertDateBrComHora(num);
  }

  if (typeof value === "number") {
    if (!Number.isFinite(value) || value <= 0) {
      return "";
    }
    return convertDateBrComHora(value);
  }

  return "";
};

const convertDateBr = (date?: number) => {
  if (date == undefined) {
    return "";
  }

  const myDate = new Date(date * 1000);
  return (
    (myDate.getUTCDate() + "").padStart(2, "0") +
    "/" +
    (myDate.getUTCMonth() + 1 + "").padStart(2, "0") +
    "/" +
    myDate.getUTCFullYear()
  );
  // return new Date(date * 1000).toLocaleDateString("en-GB");
};

const convertDateUs = (date?: number) => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toLocaleDateString();
};

const convertStringDateToBr = (date?: string) => {
  if (date == undefined) {
    return "";
  }
  const raw = String(date);
  const onlyDate = raw.substring(0, 10);
  const isoSimpleRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (isoSimpleRegex.test(onlyDate)) {
    const [y, m, d] = onlyDate.split("-");
    return `${d}/${m}/${y}`;
  }
  return new Date(raw).toLocaleDateString("pt-BR");
};

const convertDateFromUsToBr = (date?: string) => {
  if (date == undefined) {
    return "";
  }

  return date.split("-").reverse().join("/");
};

const getFullYear = () => {
  const dataAtual = new Date();
  return dataAtual.getFullYear();
};

const tomorrowDate = () => {
  const tomorrow = new Date();
  const timestamp = tomorrow.setDate(tomorrow.getDate() + 1);
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  return year + "-" + month + "-" + day;
};
export {
  convertDate,
  convertDateBr,
  convertDateBrComHora,
  convertDateBrComHoraSafe,
  convertDateFromUsToBr,
  convertDateIso,
  convertDateUs,
  convertStringDateToBr,
  getFullYear,
  tomorrowDate,
};
